// extracted by mini-css-extract-plugin
export default {"header":"NavBar_header__dafTi","navigationArea":"NavBar_navigationArea__fMVAv","mainNav":"NavBar_mainNav__D-2bn"};